<template>
  <div class="dynamic-message" @click="handleJump(list)">
    <!-- {{list}} -->
    <div class="left">
      <div v-if="list.type === 1 " class="huisuiyunfont yes">
        {{'\ue614'}}
      </div>
      <div v-else class="huisuiyunfont no">
        {{'\ue615'}}
      </div>
    </div>
    <div class="right">
      <div class="name-time">
        <div>
          {{list.type === 1 ? '票据开具成功' : list.type === 2 ? '票据开具失败' : list.type === 3 ? '票据已作废' : ''}}
        </div>
      </div>
      <div class="message-money">
        <div class="overflow">
          <div class="text">{{list.content}}</div>
          <div class="more">更多</div>
          <!-- {{list.content}} -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { invoiceRequest, messageRequest } from '@/services'
import { Notify } from 'vant'
import { onCount } from '@utils/basicUtil'
export default {
  props: {
    list: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    [Notify.name]: Notify
  },
  methods: {
    jumpTo (url) {
      this.$router.push(url)
    },
    handleJump (messageInfo) {
      if (messageInfo.type === 1) {
        this.jumpTo('/user-center/index')
      } else if (messageInfo.type === 2) {
        this.applyDetail(JSON.parse(messageInfo.attachment).settlementId + '')
      } else {
        this.jumpTo(messageInfo.url)
      }
      this.changeTodoStatus(JSON.parse(messageInfo.attachment).settlementId)
    },
    async applyDetail (id) {
      await this.getApplyDetail(id, true)
      this.$router.push('/invoice/info') // 跳转到没有按钮的详情页面
    },
    async changeTodoStatus (id) {
      await messageRequest.todo.updateById({
        id,
        handleFlag: 1
      })
    },
    getApplyDetail (id, changeInfo) {
      return new Promise(async (resolve, reject) => {
        if (!id) {
          resolve(true)
          return
        }
        const data = await invoiceRequest.apply.getApplyDetail({
          id
        })
        if (data.success) {
          let money = 0
          data.result.details.forEach(element => {
            money = onCount.add(money, element.amountWithTax)
          })
          this.files = data.result.files.map(file => {
            return {
              url: file
            }
          })
          const res = {
            ...data.result,
            files: [...this.files],
            invoiceType: String(data.result.invoiceType),
            logisticsFlag: String(data.result.logisticsFlag),
            money: String(money)
          }
          this.receiverInfo = {
            receiverName: data.result.receiverName,
            receiverAddress: data.result.receiverAddress,
            receiverPhone: data.result.receiverPhone,
            receiverEmail: data.result.receiverEmail,
            logisticsFlag: String(data.result.logisticsFlag)
          }
          if (changeInfo) {
            this.$store.commit('invoice/changeApplyData', {
              formData: res
            })
          }
          const goodsList = data.result.details.map(goods => {
            return {
              ...goods,
              price: goods.unitPrice === 0 ? null : goods.unitPrice,
              quantity: goods.quantity === 0 ? null : goods.quantity
            }
          })
          if (changeInfo) {
            this.$store.commit('invoice/changeGoodsList', goodsList)
          }
        } else {
          this.$store.commit('invoice/initApplyData')
          Notify({ type: 'danger', message: data.message })
        }
        resolve(true)
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .dynamic-message{
    width: 96%;
    margin: 16px auto 32px;
    display: flex;
    .more{
      color: #3378FF;
      font-size: 24px;
    }
    .left{
      margin-top: 20px;
      text-align: center;
      .yes{
        color: #1BC6E0;
        font-size: 40px;
      }
      .no{
        color: #FF6947;
        font-size: 40px;
      }
      div{
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin: 0 auto;
      }
    }
    .right{
      flex-grow: 1;
      .name-time{
        padding: 20px 0px 16px 32px;
        font-size: 15px;
        display: flex;
        justify-content: space-between;
        div:nth-of-type(2){
          width: 100px;
          font-size: 20px;
          color: #9EA9B9;
          text-align: right;
          padding-right: 16px;
        }
        div:nth-of-type(1){
          font-size: 26px;
          font-weight: 600;
          color: #3E4966;
          flex-grow: 1;
        }
      }
      .message-money{
        padding:0px 0px 16px 32px;
        display: flex;
        justify-content: space-between;
        .overflow{
          .text{
            width: 640px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 10px;
          }
          .more{
            width: 600px;
            text-align: left;
            color: #70A0FF;
            font-size: 24px;
          }
        }
        .message-money-i{
          font-size: 10px;
          display: inline-block;
          font-weight: 100;
          transform: scale(0.5);
        }
        div:nth-of-type(2){
          width: 100px;
          font-size: 26px;
          color: #3E4966;
          font-weight: 600;
          text-align: right;
          padding-right: 16px;
        }
        div:nth-of-type(1){
          font-size: 24px;
          color: #9EA9B9;
          flex-grow: 1;
        }
      }
    }
  }
</style>
